import { useEffect } from 'react';
import { Box, Stack } from '@mui/material';

import { LocalizationTypography } from './localization';
import { PaymentForm } from './PaymentForm';

import { TRACKING_PAGES } from '~common';
import { StripeElements } from '~components/molecules/StripeElements';
import { stripeElementsOptions } from '~configs/stripe';
import { useTenantBranding } from '~hooks/tenant/useTenantBranding';
import { useEventTrackingContext, useStationPricingContext } from '~providers';
import { formatCurrency } from '~utils';

export const StepThree = () => {
  const { termsUrl } = useTenantBranding();
  const { recordPageVisited } = useEventTrackingContext();
  const { stationPricing } = useStationPricingContext();
  const preAuthAmount = formatCurrency(
    stationPricing?.preAuthAmount,
    stationPricing?.symbol,
  );

  const onClickViewTerms = () => {
    window?.open(termsUrl, '_blank');
  };

  useEffect(() => {
    recordPageVisited(TRACKING_PAGES.SELECT_PAYMENT_METHOD);
  }, [recordPageVisited]);

  return (
    <>
      <Stack display="grid" sx={{ gridRowGap: 16 }}>
        <LocalizationTypography
          variant="h5"
          fontWeight={600}
          textId="app.rentalPage.stepThree.choosePay"
          defaultText="Choose how to pay"
        />
        <LocalizationTypography
          variant="body1"
          fontWeight={400}
          color="#6A737D"
          textId="app.rentalPage.stepThree.paymentDetails"
          textValues={{ value: preAuthAmount }}
          defaultText={`Your card will be pre-authorized for ${preAuthAmount}. This is a temporary hold and
          will be reversed within 5 business days.`}
        >
          {termsUrl && (
            <Box
              component="span"
              marginLeft={'0.3rem'}
              sx={{
                color: 'primary.main',
                fontWeight: 400,
                fontSize: '1rem',
                cursor: 'pointer',
              }}
              onClick={onClickViewTerms}
            >
              <LocalizationTypography
                disableParentTypography
                textId="app.rentalPage.stepThree.viewTerms"
                defaultText="View terms"
              />
            </Box>
          )}
        </LocalizationTypography>
      </Stack>
      <Stack display="grid" sx={{ gridRowGap: 16 }}>
        <LocalizationTypography
          variant="body1"
          fontWeight={600}
          color="brand.main"
          textId="app.rentalPage.stepThree.textRentalDetails"
          defaultText="Rental Details"
        />
        <Stack direction="row" justifyContent="space-between">
          <LocalizationTypography
            variant="body1"
            fontWeight={400}
            color="#6A737D"
            textId="app.rentalPage.stepThree.text1xCharger"
            defaultText="1x Charger"
          />
          <LocalizationTypography
            variant="body1"
            fontWeight={400}
            color="#6A737D"
            textId="app.rentalPage.stepThree.textPricingOnScreen"
            defaultText="Pricing on screen"
          />
        </Stack>
      </Stack>
      <StripeElements options={stripeElementsOptions}>
        <PaymentForm />
      </StripeElements>
    </>
  );
};
